import type { BookingPeriodAvailability } from '~/resources/graphql/graphql'

export type CalendarAvailability =
    | 'available'
    | 'fullOrClosed'
    | 'waitlist'
    | 'notOpenYet'

// Retain the booking-period state so an ended period is never labeled "Not available yet".
export type CourseCalendarInfo = {
    capacityFull: boolean
    bookingPeriodAvailability: BookingPeriodAvailability
    bookingStatus: 'open' | 'waitlist' | 'closed'
}

// Keep the visible marker and accessible date label on the same status, using
// the calendar's existing precedence when a date has multiple restrictions.
export function getCourseCalendarAvailability(
    courseInfo: CourseCalendarInfo | undefined
): CalendarAvailability | null {
    if (courseInfo === undefined) {
        return null
    }
    // Waitlist enrollment has its own opening rules and can outlast the public booking period.
    if (courseInfo.bookingStatus === 'waitlist') {
        return 'waitlist'
    }
    if (
        courseInfo.capacityFull ||
        courseInfo.bookingStatus === 'closed' ||
        courseInfo.bookingPeriodAvailability === 'AFTER_BOOKING_PERIOD'
    ) {
        return 'fullOrClosed'
    }
    if (courseInfo.bookingPeriodAvailability === 'BEFORE_BOOKING_PERIOD') {
        return 'notOpenYet'
    }
    return 'available'
}
